import { motion, AnimatePresence } from 'motion/react';
import { CheckCircle } from 'lucide-react';

interface ReportConfirmationScreenProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ReportConfirmationScreen({ isOpen, onClose }: ReportConfirmationScreenProps) {
  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-white z-50 flex items-center justify-center max-w-md mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="flex flex-col items-center"
            style={{
              paddingLeft: '40px',
              paddingRight: '40px',
            }}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.1, type: 'spring', stiffness: 300, damping: 25 }}
          >
            {/* Success Icon */}
            <motion.div
              className="flex items-center justify-center"
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: 'var(--chart-3)',
                marginBottom: '24px',
              }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 400, damping: 20 }}
            >
              <CheckCircle 
                className="w-10 h-10" 
                style={{ color: 'var(--background)' }} 
              />
            </motion.div>

            {/* Title */}
            <h2
              style={{
                fontSize: 'var(--text-xl)',
                fontWeight: 'var(--font-weight-semibold)',
                color: 'var(--foreground)',
                textAlign: 'center',
                marginBottom: '12px',
                lineHeight: '1.3',
              }}
            >
              Denúncia enviada
            </h2>

            {/* Description */}
            <p
              style={{
                fontSize: 'var(--text-base)',
                color: 'var(--muted-foreground)',
                textAlign: 'center',
                lineHeight: '1.6',
              }}
            >
              Obrigado por nos ajudar a manter a qualidade dos pedidos.
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
